// eslint-disable-next-line no-undef
const ajax_object = KLAVAN_ajax_object
const ajaxUrl = ajax_object.ajax_url
const nonce = ajax_object.nonce
const registerButtons = document.querySelectorAll(".register-button")
const clientId =
  "350905201758-rcmk4ilu2mrr4d6342to2jgftb8gi2dk.apps.googleusercontent.com"
const fbAppId = "23896996859913532"
const siteUrl = window.location.origin + "/"

// Detect if we're in a Facebook or Instagram in-app browser
const isInAppBrowser = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera
  return (
    userAgent.indexOf("FBAN") > -1 ||
    userAgent.indexOf("FBAV") > -1 ||
    userAgent.indexOf("Instagram") > -1
  )
}

/**
 * Sets a status message with animation
 * @param {string} message - The message to display
 * @param {boolean} isError - Whether this is an error message
 * @param {Object} options - Additional options
 */
function setStatus(message, isError = false, options = {}) {
  // Get or create status element
  let statusElement = document.getElementById("status")

  if (!statusElement) {
    statusElement = document.createElement("div")
    statusElement.id = "status"
    statusElement.className = "registration-status"
    document.body.appendChild(statusElement)
  }

  // Set the message
  statusElement.innerHTML = message

  // Add error class if it's an error
  if (isError) {
    statusElement.classList.add("error")
  } else {
    statusElement.classList.remove("error")
  }

  // Show with animation
  statusElement.classList.remove("fade-out")
  statusElement.classList.add("fade-in")
  statusElement.style.display = "block"

  // If there's already a timer, clear it
  if (window.statusTimeout) {
    clearTimeout(window.statusTimeout)
    clearTimeout(window.fadeTimeout)
  }

  // Set timeout to hide after 5 seconds
  window.statusTimeout = setTimeout(() => {
    statusElement.classList.remove("fade-in")
    statusElement.classList.add("fade-out")

    // Hide completely after fade-out animation completes
    window.fadeTimeout = setTimeout(() => {
      statusElement.style.display = "none"
    }, 500) // Match this to the CSS animation duration
  }, 5000)
}

window.fbAsyncInit = function () {
  FB.init({
    appId: fbAppId,
    cookie: true, // Enable cookies to allow the server to access the session.
    xfbml: true, // Parse social plugins on this webpage.
    version: "v22.0", // Use this Graph API version for this call.
  })
}

function FacebookLogIn() {
  const redirectUri = encodeURIComponent(siteUrl)

  // // Store state for when user returns
  sessionStorage.setItem("fbLoginPending", "true")

  // // Redirect to Facebook OAuth directly
  window.location.href = `https://www.facebook.com/v22.0/dialog/oauth?client_id=${fbAppId}&redirect_uri=${redirectUri}&response_type=token&scope=public_profile,email`
}

function refreshMembersAfterLogin() {
  fetch(ajaxUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: new URLSearchParams({
      action: "refreshMembersAfterLogin",
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok: " + response.statusText)
      }
      return response.json()
    })
    .then((data) => {
      // Update members list
      const membersData = JSON.parse(data.members)
      document.getElementById("members-list-container").innerHTML =
        membersData.data

      // Update members count
      document.getElementById("members-count-container").innerHTML =
        data.count.html

      // Reset pagination counter after refreshing the members list
      if (window.resetKlavanPagination) {
        window.resetKlavanPagination()
      }
    })
    .catch((error) => {
      console.error("Error refreshing members data:", error)
    })
}

function GoogleLogin() {
  const redirectUri = siteUrl
  const url = `/wp-admin/admin-ajax.php?action=initiate_google_oauth&redirect_uri=${encodeURIComponent(
    redirectUri,
  )}`
  window.location.href = url
}

// Replace individual button event listeners with a forEach on all register buttons
registerButtons.forEach((button) => {
  button.addEventListener("click", function (e) {
    e.preventDefault()
    const provider = this.dataset.provider

    // Close the modal if the closeModalFunction exists
    if (typeof window.closeModalFunction === "function") {
      window.closeModalFunction()
    }

    if (provider === "facebook") {
      FacebookLogIn()
    } else if (provider === "google") {
      GoogleLogin()
    }
  })
})

function addFacebookShareDialog() {
  const container = document.body

  // Check if share container already exists
  let shareContainer = document.querySelector(".share-container")

  if (container && !shareContainer) {
    shareContainer = document.createElement("div")
    shareContainer.className = "share-container"

    const shareButton = document.createElement("a")
    shareButton.innerText = "Jaga Facebookis"
    shareButton.className = "button white"
    shareButton.href = `https://www.facebook.com/dialog/share?app_id=${fbAppId}&display=page&href=${encodeURIComponent(
      siteUrl,
    )}&redirect_uri=${encodeURIComponent(siteUrl)}&hashtag=%23teamklavan`

    shareContainer.appendChild(shareButton)
    container.appendChild(shareContainer)

    setTimeout(() => {
      shareContainer.classList.add("fade-in")

      // If there's already a share timer, clear it
      if (window.shareTimeout) {
        clearTimeout(window.shareTimeout)
      }
    }, 100)
  }
}

// Add this code to handle the redirect return
function checkFacebookRedirectReturn() {
  // Check if we have a pending Facebook login and we're returning from auth
  if (
    sessionStorage.getItem("fbLoginPending") &&
    window.location.hash.includes("access_token=")
  ) {
    sessionStorage.removeItem("fbLoginPending")

    // Parse the access token from URL fragment
    const accessToken = new URLSearchParams(
      window.location.hash.substring(1),
    ).get("access_token")

    if (accessToken) {
      // Use the token to fetch user data
      fetch(
        `https://graph.facebook.com/v22.0/me?fields=id,first_name,last_name,email,picture&access_token=${accessToken}`,
      )
        .then((response) => response.json())
        .then((userData) => {
          // Process the user data similar to your existing callback
          fetch(ajaxUrl, {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams({
              action: "add_facebook_team_member",
              security: nonce,
              user_data: JSON.stringify(userData),
            }),
          })
            .then((response) => response.json())
            .then((data) => {
              setStatus(data.data)
              refreshMembersAfterLogin()
              addFacebookShareDialog()
            })
            .catch((error) => {
              console.error("Error:", error)
              setStatus(
                "Vabandame, liitumisel tekkis viga. Palun proovige hiljem uuesti.",
                true,
              )
            })
        })
        .catch((error) => {
          console.error("Error fetching user data:", error)
          setStatus(
            "Vabandame, liitumisel tekkis viga. Palun proovige hiljem uuesti.",
            true,
          )
        })
    }
  }
}

function checkGoogleRedirectReturn() {
  const urlParams = new URLSearchParams(window.location.search)
  const oauthStatus = urlParams.get("oauth_status")
  const message = urlParams.get("message")

  if (oauthStatus === "success" && message) {
    setStatus(decodeURIComponent(message))

    // Optional: refresh member list or data
    if (typeof refreshMembersAfterLogin === "function") {
      refreshMembersAfterLogin()
    }

    // Clean up URL so the message doesn't stick in browser history
    window.history.replaceState({}, document.title, window.location.pathname)
  }
}

// Call this when page loads
document.addEventListener("DOMContentLoaded", function () {
  checkFacebookRedirectReturn()
  checkGoogleRedirectReturn()

  // Hide Google login button in in-app browsers
  if (isInAppBrowser()) {
    const googleButton = document.querySelector('[data-provider="google"]')
    if (googleButton) {
      googleButton.style.display = "none"
    }
  }
})
